import { translate } from './translate';

const formatBoolean = (item: string): string => translate(item, `booleanToYesNo.`);
export const booleanToYesNoFormatter = (params: any): string =>
  params?.value === undefined ? '' : formatBoolean(params.value);
